import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { setOpenPopup } from '#action/project/devices-popup';
import ArrowRightButton from '#component/general/arrow-right-button';
import { ShowMoreContainer } from './styles';
import DevicesModal from './device-modal/devices-modal';

const DevicesCountButton = ({ devicesCount, project, devices }) => {
  const dispatch = useDispatch();
  const [openDevicePopup, setOpenDevicePopup] = useState(false);

  const handleOpenDevicePopup = () => {
    setOpenDevicePopup(!openDevicePopup);
    dispatch(setOpenPopup(!openDevicePopup, false));
  };

  if (!devicesCount && !openDevicePopup) {
    return null;
  }

  return (
    <>
      <ShowMoreContainer>
        <Typography color="textSecondary" fontWeight="bold">
          {devicesCount}
        </Typography>
        <ArrowRightButton onClickArrowRight={handleOpenDevicePopup} />
      </ShowMoreContainer>
      {(openDevicePopup) &&
        <DevicesModal
          project={project}
          devices={devices}
          isOpen={openDevicePopup}
          handleIsOpen={setOpenDevicePopup}
        />}
    </>
  );
};

export default DevicesCountButton;
